const KEY = "ticketing:lastSeenActivityAt";

type MapShape = Record<string, string>; // ticketId -> iso

function read(): MapShape {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === "object") return parsed as MapShape;
    return {};
  } catch {
    return {};
  }
}

function write(map: MapShape) {
  try {
    localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // ignore
  }
}

export function getLastSeen(ticketId: number): string | null {
  const m = read();
  return m[String(ticketId)] ?? null;
}

export function setLastSeen(ticketId: number, iso: string) {
  const m = read();
  m[String(ticketId)] = iso;
  write(m);
}
